<template>
  <div>
    <h1>Impressum Shop</h1>
    <SearchBar @search="updateSearch" id="search" />
    <AdressList :addresses="addresses" :searchQuery="searchQuery" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import AdressList from "@/components/AdressList.vue";

export default {
  components: {
    SearchBar,
    AdressList,
  },
  data() {
    return {
      searchQuery: "",
      addresses: [
        {
          name: "Bahnhofstrasse 10",
          street: "Bahnhofstrasse",
          city: "Zürich",
          zip: "8001",
        },
        {
          name: "Bundesplatz 1",
          street: "Bundesplatz",
          city: "Bern",
          zip: "3005",
        },
        {
          name: "Rue de Lausanne 45",
          street: "Rue de Lausanne",
          city: "Genf",
          zip: "1202",
        },
        {
          name: "Feldstrasse 8",
          street: "Feldstrasse",
          city: "Basel",
          zip: "4057",
        },
        {
          name: "Freie Strasse 22",
          street: "Freie Strasse",
          city: "Basel",
          zip: "4001",
        },
        {
          name: "Bahnhofplatz 5",
          street: "Bahnhofplatz",
          city: "Luzern",
          zip: "6003",
        },
        {
          name: "Bahnhofstrasse 18",
          street: "Bahnhofplatz",
          city: "Zug",
          zip: "3200",
        },
        {
          name: "Seefeldstrasse 20",
          street: "Seefeldstrasse",
          city: "Zürich",
          zip: "8008",
        },
        {
          name: "Poststrasse 7",
          street: "Poststrasse",
          city: "St. Gallen",
          zip: "9001",
        },
        {
          name: "Rennweg 12",
          street: "Rennweg",
          city: "Zürich",
          zip: "8001",
        },
        {
          name: "Avenue de Montchoisi 14",
          street: "Avenue de Montchoisi",
          city: "Lausanne",
          zip: "1006",
        },
      ],
    };
  },
  methods: {
    updateSearch(query) {
      this.searchQuery = query;
    },
  },
};
</script>
<style scoped>
h1 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}

#search {
  margin: 0 auto;
  margin-top: 20px;
}
</style>
